import classNames from "classnames";
import LinkIcon from "assets/icons/LinkIcon";
import styles from "./styles.module.scss";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import FindSimilarIcon from "assets/icons/FindSimilarIcon";

interface ActionButtonsProps {
  linkClicked: boolean;
  showSimilarityButton: boolean;
  onLinkClick: () => void;
  onSimilarityClick: () => void;
}

const ActionButtons = ({
  linkClicked,
  onLinkClick,
  onSimilarityClick,
  showSimilarityButton,
}: ActionButtonsProps) => {
  return (
    <div className={styles.actionButtons}>
      <div
        className={classNames(styles.actionButton, styles.noDetailsClick)}
        onClick={onLinkClick}
        data-tooltip-id={"assetpreview-link-button-tooltip"}
        data-tooltip-content={linkClicked ? "Copied!" : "Copy URL"}
      >
        <LinkIcon clicked={linkClicked} />

        <TooltipWrapper id="assetpreview-link-button-tooltip" />
      </div>
      {showSimilarityButton && (
        <div
          onClick={onSimilarityClick}
          className={classNames(styles.actionButton, styles.noDetailsClick)}
          data-tooltip-content="Find Similar"
          data-tooltip-id="assetpreview-find-similar-button-tooltip"
        >
          <FindSimilarIcon />
          <TooltipWrapper id="assetpreview-find-similar-button-tooltip" />
        </div>
      )}
    </div>
  );
};

export default ActionButtons;
